import React, { Suspense } from 'react';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import moment from 'moment';

const TimePickerComponent = ({
    label,
    value,
    onChange,
    disableClock = true,
    clearIcon = null,
    clockIcon = null,
    format = 'hh:mm a',
    hourPlaceholder = 'hh',
    minutePlaceholder = 'mm',
    secondPlaceholder = 'ss',
    maxTime,
    minTime,
    disabled = false,
    required = false,
    name,
    className,
    amPmAriaLabel = 'Select AM/PM',
}) => {

    const parsed = moment(value, ['hh:mm A', 'HH:mm'], true);
    const timePickerValue = parsed.isValid() ? parsed.format('HH:mm') : null;

    // Format the selected time and send to parent
    const handleChange = (newTime) => {
        if (onChange && newTime) {
            const formatted = moment(newTime, 'HH:mm').format(format);
            onChange(formatted);
        }
    };

    return (
        <div className={`time-picker-wrapper ${className || ''}`} style={{ marginBottom: '1rem' }}>
            <Suspense fallback={<div>Loading...</div>}>
                <TimePicker
                    onChange={handleChange}
                    value={timePickerValue}
                    disableClock={disableClock}
                    clearIcon={clearIcon}
                    clockIcon={clockIcon}
                    format={format}
                    hourPlaceholder={hourPlaceholder}
                    minutePlaceholder={minutePlaceholder}
                    secondPlaceholder={secondPlaceholder}
                    maxTime={maxTime}
                    minTime={minTime}
                    disabled={disabled}
                    required={required}
                    name={name}
                    amPmAriaLabel={amPmAriaLabel}
                />
            </Suspense>
        </div>
    );
};

export default TimePickerComponent;
